import React, { useCallback } from 'react';
import { ScrollView, View } from 'react-native';
import { Background, LabeledSwitch, OptionsSelectBox } from 'LocalGluons';
import { t } from 'Locale';
import storeActions from 'Store/storeActions';
import { useStore } from 'Store';

import defaultStyles from './NetworkSettings.jss';

const WIFI_ONLY_ITEM_ID = 'NETWORK.WIFI_ONLY';
const WIFI_CELLULAR_ITEM_ID = 'NETWORK.WIFI_CELLULAR';

const NetworkSettings = () => {
    const items = [
        {
            id: WIFI_ONLY_ITEM_ID,
            label: t(WIFI_ONLY_ITEM_ID)
        },
        {
            id: WIFI_CELLULAR_ITEM_ID,
            label: t(WIFI_CELLULAR_ITEM_ID)
        }
    ];

    const { deviceStorageState, deviceStorageDispatch } = useStore();
    const { videoStreamingOverCellular, showMobileNetworkWarning, downloadsOverCellular } =
        deviceStorageState;

    const selectedStream = videoStreamingOverCellular ? WIFI_CELLULAR_ITEM_ID : WIFI_ONLY_ITEM_ID;
    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line no-unused-vars
    const selectedDownloads = downloadsOverCellular ? WIFI_CELLULAR_ITEM_ID : WIFI_ONLY_ITEM_ID;

    const changeStreamCallback = useCallback((itemId) => {
        deviceStorageDispatch({
            type: storeActions.setVideoStreamingOverCellular,
            payload: itemId === WIFI_CELLULAR_ITEM_ID
        });
    }, []);

    const switchChangeCallback = useCallback((value) => {
        deviceStorageDispatch({
            type: storeActions.setShowMobileNetworkWarning,
            payload: value
        });
    }, []);

    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line no-unused-vars
    const changeDownloadsCallback = useCallback((itemId) => {
        deviceStorageDispatch({
            type: storeActions.setDownloadsOverCellular,
            payload: itemId === WIFI_CELLULAR_ITEM_ID
        });
    }, []);

    return (
        <Background>
            <ScrollView style={defaultStyles.container}>
                <OptionsSelectBox
                    heading={t('NETWORK.VIDEO_STREAMING').toUpperCase()}
                    onChange={changeStreamCallback}
                    items={items}
                    selected={selectedStream}
                    localeLabels
                />

                {selectedStream === WIFI_CELLULAR_ITEM_ID && (
                    <View style={defaultStyles.labeledSwitch}>
                        <LabeledSwitch
                            label={t('NETWORK.DATA_WARNING_TXT')}
                            value={showMobileNetworkWarning}
                            onValueChange={switchChangeCallback}
                        />
                    </View>
                )}
                {/* TODO: TEMPORARILY HIDDEN UNTIL DOWNLOADS WILL BE ENABLED AGAIN */}
                {/* <OptionsSelectBox */}
                {/*    heading={t('NETWORK.DOWNLOADS').toUpperCase()} */}
                {/*    onChange={changeDownloadsCallback} */}
                {/*    items={items} */}
                {/*    selected={selectedDownloads} */}
                {/*    localeLabels */}
                {/* /> */}
            </ScrollView>
        </Background>
    );
};

export { NetworkSettings };
